const file = require('../components/file/file')
const textfield = require('../components/textfield/textfield')
const purchase = require('../applications/staff/desktop/entity/purchase/purchase')
const sale = require('../applications/staff/desktop/entity/sale/sale')
const customer = require('../applications/staff/desktop/entity/customer/customer')
const provider = require('../applications/staff/desktop/entity/provider/provider')
const dashboard = require('../applications/staff/desktop/entity/dashboard/dashboard')
const users = require('../applications/staff/desktop/entity/users/users')

// cliente
const clientActivity = require('../applications/client/desktop/entity/clientActivity/clientActivity')
const clientPurchase = require('../applications/client/desktop/entity/clientPurchase/clientPurchase')
const clientSale = require('../applications/client/desktop/entity/clientSale/clientSale')
const clientCustomer = require('../applications/client/desktop/entity/clientCustomer/clientCustomer')
const clientProvider = require('../applications/client/desktop/entity/clientProvider/clientProvider')

const customerProfit = require('../applications/staff/desktop/entity/customerProfit/customerProfit')

export const obj = {

        file: { start: function (detail) { file.start(detail) } },
        textfield: { start: function (detail) { textfield.start(detail) } },
        sale: { start: function (detail) { sale.start(detail) } },
        purchase: { start: function (detail) { purchase.start(detail) } },
        customer: { start: function (detail) { customer.start(detail) } },
        provider: { start: function (detail) { provider.start(detail) } },
        dashboard: { start: function (detail) { dashboard.start(detail) } },
        users: { start: function (detail) { users.start(detail) } },


        clientActivity: { start: function (detail) { clientActivity.start(detail) } },
        clientPurchase: { start: function (detail) { clientPurchase.start(detail) } },
        clientSale: { start: function (detail) { clientSale.start(detail) } },
        clientCustomer: { start: function (detail) { clientCustomer.start(detail) } },
        clientProvider: { start: function (detail) { clientProvider.start(detail) } },

        customerProfit: { start: function (detail) { customerProfit.start(detail) } },


}